import { PlanType, SubscribePlan } from '../../../../types';
import { getSubscriptionPlanLevel } from '../../subscription';
import { usePlanPaymentInfoContext } from '../PlanPaymentSection/Providers';
import { PaymentStatusType } from '../types';

const DEFAULT_FREE_MAX_CCU = 10;

/**
 * 결제하려는 플랜과 사용중인 플랜을 비교해서 각 상황에 필요한 상태를 반환한다.
 * 상황에따라 여러가지 상태가 활성화될 수 있습니다.
 * PlanPaymentInfoProvider와 PlanPaymentFormProvider에 의존합니다.
 * @param planType
 */
export const usePlanStatusType = ({
  planType,
}: {
  planType: Omit<SubscribePlan, 'free'>;
}): PaymentStatusType => {
  const { selectedPlanInfo, planPaymentInfo } = usePlanPaymentInfoContext();

  const selectedPlanLevel: number = getSubscriptionPlanLevel(
    planType.toUpperCase() as Partial<PlanType>,
  );
  const nowPlanLevel: number = getSubscriptionPlanLevel(
    planPaymentInfo?.spacePlan?.planType ?? 'FREE',
  );

  const currentMaxCcu =
    planPaymentInfo?.spacePlan?.maxCcu || DEFAULT_FREE_MAX_CCU;
  const selectedMaxCcu = selectedPlanInfo.maxCcu;

  const isSamePlan =
    selectedPlanLevel === nowPlanLevel && currentMaxCcu === selectedMaxCcu;

  const isUpgradePlan =
    currentMaxCcu < selectedMaxCcu || selectedPlanLevel > nowPlanLevel;

  const isPlanReserved =
    planPaymentInfo?.subscription?.nextSpacePlanTemplateId ===
    selectedPlanInfo.id;

  const isDowngradePlan = !isUpgradePlan && !isSamePlan;

  // 우선순위에 따른 반환
  if (isPlanReserved) {
    return 'RESERVED_GRADE';
  }

  if (isSamePlan) {
    return 'SAME_GRADE';
  }

  if (isUpgradePlan) {
    return 'UP_GRADE';
  }

  if (isDowngradePlan) {
    return 'DOWN_GRADE';
  }

  return 'NONE_UPGRADE';
};
